import { isArrayLike } from 'mobx';

export class ObjectUtils {
	public static parseError(error: any): string[] | string {
		if (!error)
			return 'Unknown error';
		if (error.data &&
			error.data.response &&
			error.data.response.body) {
			try {
				const messages = [];
				let body = JSON.parse(error.data.response.body);
				if (body.error) {
					body = body.error;
					if (body.message)
						messages.push(body.message);
					let innererror = body.innererror;
					while (innererror) {
						if (innererror.message)
							messages.push(innererror.message);
						innererror = innererror.internalexception;
					}
					return messages;
				}
			} catch (ex) {
				return error.toString();
			}
		}
		if (error.response && error.response.data) {
			const messages = [];

			const body = error.response.data;
			let message = body.message;
			if (body.exceptionMessage) {
				message += ": " + body.exceptionMessage
			}
			messages.push(message);

			return messages;
		}
		if (Array.isArray(error)) {
			try {
				const messages = [];
				for (let idx in error) {
					const item = error[idx];
					if (item.errors) {
						for (let errIdx in item.errors) {
							const err = item.errors[errIdx];
							messages.push(`${err.PropertyDefinition.name}: ${err.Message}`);
						}
					}
				}
				return messages;
			} catch (ex) {
				return error.toString();
			}
		}
		return error.toString();
	}

	public static equals(obj1: any, obj2: any, checked?: Map<any, any[]>): boolean {
		if (typeof obj1 != typeof obj2) {
			return false;
		}
		if ((obj1 != null && obj2 == null) || (obj2 != null && obj1 == null))
			return false;
		if (checked == null) {
			checked = new Map<any, any>();
		}

		let list1 = checked.get(obj1) || [];
		let list2 = checked.get(obj2) || [];
		if (list1.find(m => m == obj2) || list2.find(m => m == obj1)) {
			return true;
		}
		list1.push(obj2);
		list2.push(obj1);
		checked.set(obj1, list1);
		checked.set(obj2, list2);

		if (obj1 instanceof Date) {
			// Date
			return obj2 instanceof Date &&
				obj1.getTime() == obj2.getTime();
		} else if (isArrayLike(obj1)) {
			// Array
			return obj1.length === obj2.length
				&& obj1.every((_, i) => ObjectUtils.equals(obj1[i], obj2[i], checked));
		} else if (obj1 instanceof Object) {
			// Object
			return Object.keys(obj1).length === Object.keys(obj2).length
				&& Object.keys(obj1).every((prop) => ObjectUtils.equals(obj1[prop], obj2[prop], checked));
		} else {
			// Primitive types
			return obj1 == obj2;
		}
	}

	public static deepCopy(obj: any, exclude?: (prop: string) => boolean) {
		let copy;

		// Handle the 3 simple types, and null or undefined
		if (null == obj || 'object' != typeof obj) return obj;

		// Handle Date
		if (obj instanceof Date) {
			copy = new Date();
			copy.setTime(obj.getTime());
			return copy;
		}

		// Handle Array
		if (obj instanceof Array) {
			copy = [];
			for (let i = 0, len = obj.length; i < len; i++) {
				copy[i] = ObjectUtils.deepCopy(obj[i], exclude);
			}
			return copy;
		}

		// Handle Object
		if (obj instanceof Object) {
			copy = {};
			for (const attr in obj) {
				if (exclude && exclude(attr))
					continue;
				if (obj.hasOwnProperty(attr)) copy[attr] = ObjectUtils.deepCopy(obj[attr], exclude);
			}
			return copy;
		}

		throw new Error("Unable to copy obj! Its type isn't supported.");
	}

	static toObject<T>(str: string): T {
		return JSON.parse(str) as T;
	}

	static toString(obj: any): string {
		return JSON.stringify(obj);
	}

	static round(num: number, places: number = 2): number {
		const units = Math.pow(10, places);
		return Math.round(units * num) / units;
	}

	static getDateFromOffset(date: Date, millisecondsOffset: number): Date {
		const newDate = new Date(date);
		newDate.setMilliseconds(newDate.getMilliseconds() + millisecondsOffset);

		return newDate;
	}
}



// WEBPACK FOOTER //
// ./src/core/utils/object.ts